module.exports = __webpack_public_path__ + "img/4-2.1cd0562f.svg";